import { createPortal } from "react-dom";
import { message } from "antd";
import { useEffect, useRef, useState } from "react";

import MeetingLinkView from "./LinkMeetingView";
import Dialog from "@/component/Dialog";
import IC_CLOSE_WIN from "@/assets/common/ic_collect_close.svg?react";
import IC_WARNING from "@/assets/flow/ic_warning.svg?react";
import BG_SYNC_BODY from "@/assets/flow/bg_sync.png";
import ConnectView from "./ConnectView";
import ChoseTypeView from "./ChoseTypeView";
import { ProcessView } from "./ProcessView";
import dataFolwStore from "@/store/endSideFlow.store";
import { ScreenShareRecorder } from "@core/ability";

interface IProp {
  onClose: () => void;
}

// 链接流转
export default function LinkFlow(prop: IProp) {
  // const isSupportExport = appStore((state) => state.isSupportExport);

  const [activeType] = useState('OnlineLink');

  // 端侧流转的变量
  const [showDialog, setShowDialog] = useState(false);
  const section = dataFolwStore((store) => store.section);
  const waitRetryUpload = dataFolwStore((store) => store.waitRetryUpload);
  const screenShareRecorder = useRef<ScreenShareRecorder>(new ScreenShareRecorder());

  useEffect(() => {
    linstenConnectStatus();
    return () => { }
  }, []);


  // const switchTab = (type: string) => {
  //   console.log('type = ', type);
  //   if (type == 'OnlineLink') {
  //     if (section == 3) {
  //       message.error("传输过程无法切换窗口");
  //       return;
  //     }
  //     setActiveType(type);
  //   } else {
  //     exportHandle();
  //     console.log('切换到端侧流转');
  //   }
  // }

  const linstenConnectStatus = () => {
    screenShareRecorder.current.on('deviceDisconnected', (error) => {
      console.log(error);
    });
  }

  // const exportHandle = async () => {
  //   fridayReporter.pushData({
  //     eventCode: 'HomePage_GetFiles'
  //   })
  //   setActiveType('LocalPull');
  // };

  const retryHandle = () => {
    if (waitRetryUpload) {
      dataFolwStore.getState().changeSection(3);
    } else {
      dataFolwStore.getState().resetStore();
      screenShareRecorder.current.handleDisconnect();
    }
  }

  const confirmClose = () => {
    setShowDialog(false);
    dataFolwStore.getState().resetStore();
    screenShareRecorder.current.handleDisconnect();
    prop.onClose();
  }

  const closeHandle = (isCustom?: boolean) => {
    if (activeType != 'OnlineLink') {
      prop.onClose();
    } else {
      if (isCustom && section == 3) {
        message.error("传输过程无法关闭窗口");
        return;
      }
      if (dataFolwStore.getState().waitRetryUpload) {
        setShowDialog(true);
        return;
      }
      dataFolwStore.getState().resetStore();
      screenShareRecorder.current.handleDisconnect();
      prop.onClose();
    }
  }

  const buildErrorView = () => {
    return (
      <div className="flex flex-col items-center mt-8.5">
        <IC_WARNING className="w-12 h-12"></IC_WARNING>
        <span className="text-size-4 text-black mt-6 font-bold">{waitRetryUpload ? '网络异常，请检测网络后重试' : '保存异常'}</span>
        <div className="cursor-pointer w-36.5 h-10 mt-6 py-0 lh-10 px-2.5 font-size-3 b-1 b-solid rounded-2.5 b-#4981F2 bg-#4981F2 color-#ffffff select-none text-center hover:opacity-80% active:opacity-50%"
          onClick={retryHandle}>重试</div>
      </div>
    );
  }

  return createPortal(
    <div className="fixed top-0 w-full h-full bg-black bg-opacity-50">
      <Dialog isOpen={showDialog} title="确认退出操作" content="删除后，需要重新开始同步记录" onCancel={() => { setShowDialog(false); }} onConfirm={confirmClose} confirmText="退出"></Dialog>
      <div className="absolute flex flex-col w-125 h-106 rd-2.5 left-1/2 top-1/2 -translate-1/2 bg-white overflow-hidden bg-no-repeat bg-contain"
        style={{ backgroundImage: `url(${BG_SYNC_BODY})` }}>
        <div className="relative flex items-center justify-center w-full h-12">
          <span className='text-size-4.5 text-#191D26 font-500 select-none'>会中加入</span>
          <IC_CLOSE_WIN className="absolute w-6 h-6 cursor-pointer right-3 z-99"
            onClick={() => { closeHandle(true) }}>
          </IC_CLOSE_WIN>
        </div>
        {activeType === 'OnlineLink' ?
          <MeetingLinkView linkType="LocalLink" /> :
          (section == 1 ?
            <ConnectView screenShareRecorder={screenShareRecorder.current} /> :
            section == 2 ?
              <ChoseTypeView /> :
              section == 3 ?
                <ProcessView screenShareRecorder={screenShareRecorder.current} doneCallback={closeHandle} /> :
                buildErrorView()
          )
        }
      </div>
    </div >,
    document.body
  );
}